<div class="kl-page">
  <div class="kl-head">
    <h2 class="kl-title">Customers</h2>
    <span class="kl-spacer"></span>
    <mat-button-toggle-group [(ngModel)]="viewMode" aria-label="View mode" class="kl-view-toggle">
      <mat-button-toggle value="table"><mat-icon>table_rows</mat-icon> Table</mat-button-toggle>
      <mat-button-toggle value="board"><mat-icon>view_kanban</mat-icon> Pipeline</mat-button-toggle>
    </mat-button-toggle-group>
    <button mat-stroked-button (click)="exportExcel()" [disabled]="exporting"
            matTooltip="Download the listed customers as Excel with every card field, incl. PowerOffice customer no, contacts, systems and groups">
      <mat-icon>download</mat-icon> {{ exporting ? 'Exporting…' : 'Export' }}
    </button>
    <button mat-flat-button color="primary" *ngIf="canEdit" (click)="addKunde()">
      <mat-icon>add</mat-icon> New customer
    </button>
  </div>

  <!-- Quick filters double as the summary -->
  <div class="kl-stats">
    <button type="button" class="kl-stat" [class.active]="quickFilter === 'all'" (click)="setQuickFilter('all')">
      <span class="kl-stat-value">{{ stats.all }}</span><span class="kl-stat-label">Customers</span>
    </button>
    <button type="button" class="kl-stat" [class.active]="quickFilter === 'withSystems'" (click)="setQuickFilter('withSystems')">
      <span class="kl-stat-value">{{ stats.withSystems }}</span><span class="kl-stat-label">With systems</span>
    </button>
    <button type="button" class="kl-stat" [class.active]="quickFilter === 'noSystems'" (click)="setQuickFilter('noSystems')">
      <span class="kl-stat-value">{{ stats.noSystems }}</span><span class="kl-stat-label">No systems</span>
    </button>
    <button type="button" class="kl-stat kl-stat--warn" [class.active]="quickFilter === 'missingKundenr'" (click)="setQuickFilter('missingKundenr')">
      <span class="kl-stat-value">{{ stats.missingKundenr }}</span><span class="kl-stat-label">Missing Kundenr</span>
    </button>
    <button type="button" class="kl-stat" [class.active]="quickFilter === 'openTasks'" (click)="setQuickFilter('openTasks')">
      <span class="kl-stat-value">{{ stats.openTasks }}</span><span class="kl-stat-label">With open tasks</span>
    </button>
    <button type="button" class="kl-stat kl-stat--warn" [class.active]="quickFilter === 'lease'" (click)="setQuickFilter('lease')"
            matTooltip="A system's lease has ended or ends within 30 days">
      <span class="kl-stat-value">{{ stats.lease }}</span><span class="kl-stat-label">Lease ending</span>
    </button>
  </div>

  <div class="kl-toolbar">
    <div class="kl-search">
      <mat-icon>search</mat-icon>
      <input type="search" [(ngModel)]="search" (ngModelChange)="applyFilters()"
             placeholder="Search name, org no., Kundenr, email, system…" aria-label="Search customers">
      <button *ngIf="search" type="button" class="kl-search-clear" aria-label="Clear search" (click)="clearSearch()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <select class="custom-select custom-select-sm kl-select" [(ngModel)]="categoryFilter" (ngModelChange)="applyFilters()" aria-label="Filter by category">
      <option [ngValue]="null">All categories</option>
      <option *ngFor="let c of categoryFilterOptions" [ngValue]="c">{{ c }}</option>
    </select>
    <mat-checkbox [(ngModel)]="myAccountsOnly" (ngModelChange)="applyFilters()">My accounts only</mat-checkbox>
    <mat-checkbox [ngModel]="groupByOrg" (ngModelChange)="setGroupByOrg($event)"
                  matTooltip="Show units (schools, sites) under their parent organisation. Sorting is by name while this is on.">Organisation tree</mat-checkbox>
    <span class="kl-spacer"></span>
    <span class="kl-count" *ngIf="viewMode === 'table'">{{ filteredCount }} shown</span>
  </div>

  <div class="kl-table-wrap" [hidden]="viewMode !== 'table'">
    <table mat-table [dataSource]="dataSource" matSort matSortActive="name" matSortDirection="asc" [matSortDisabled]="groupByOrg" [trackBy]="trackRow" class="kl-table">

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Customer</th>
        <td mat-cell *matCellDef="let r">
          <div class="kl-customer" [class.kl-customer--unit]="r._depth === 1" [class.kl-dimmed]="r._dimmed">
            <button *ngIf="groupByOrg && r._depth === 0 && r._unitCount" type="button" class="kl-tree-toggle"
                    [attr.aria-label]="(r._expanded ? 'Collapse ' : 'Expand ') + r.name" [attr.aria-expanded]="r._expanded"
                    (click)="toggleOrg(r, $event)">
              <mat-icon>{{ r._expanded ? 'expand_more' : 'chevron_right' }}</mat-icon>
            </button>
            <span *ngIf="groupByOrg && r._depth === 0 && !r._unitCount" class="kl-tree-spacer"></span>
            <mat-icon *ngIf="r._depth === 1" class="kl-unit-icon">subdirectory_arrow_right</mat-icon>
            <span class="kl-avatar">{{ r._initials }}</span>
            <div class="kl-customer-main">
              <div class="kl-name">{{ r.name || 'No name' }}
                <span *ngIf="r._unitCount" class="kl-pill kl-pill--org">{{ r._unitCount }} unit{{ r._unitCount > 1 ? 's' : '' }}</span>
                <span *ngIf="r._lease" class="kl-pill" [ngClass]="r._lease.state === 'ended' ? 'kl-pill--risk' : 'kl-pill--warn'">
                  {{ r._lease.state === 'ended' ? 'Lease ended' : 'Lease ends in ' + r._lease.days + ' d' }}
                </span>
              </div>
              <div class="kl-sub kl-part-of" *ngIf="r._parentName && (!groupByOrg || r._depth === 0)">Part of {{ r._parentName }}</div>
              <div class="kl-sub">
                <span *ngIf="r.orgId">Org. {{ r.orgId }}</span>
                <span *ngIf="r.city">{{ r.city }}</span>
                <span *ngIf="r.email">{{ r.email }}</span>
                <span *ngIf="r.phone">{{ r.phone }}</span>
              </div>
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="kundenr">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Kundenr</th>
        <td mat-cell *matCellDef="let r">
          <span *ngIf="r.powerOfficeCustomerNo; else noKundenr" class="kl-mono">{{ r.powerOfficeCustomerNo }}</span>
          <ng-template #noKundenr><span class="kl-pill kl-pill--warn" matTooltip="Invoices to this customer can't be sent to PowerOffice">Missing</span></ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="category">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Category</th>
        <td mat-cell *matCellDef="let r">
          <span class="kl-pill" [ngClass]="'kl-cat--' + (r.category || 'none').toLowerCase()">{{ r.category || '—' }}</span>
          <div class="kl-sub" *ngIf="r.customerType">{{ r.customerType }}</div>
        </td>
      </ng-container>

      <ng-container matColumnDef="systems">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Systems</th>
        <td mat-cell *matCellDef="let r" class="kl-systems-cell">
          <span *ngIf="!r._systems.length && !r._unitSystems" class="kl-muted">—</span>
          <div class="kl-systems" *ngIf="r._systems.length">
            <span *ngFor="let s of r._systemsShown" class="kl-sys" [class.kl-sys--off]="!s.active"
                  [matTooltip]="s.active ? s.name : s.name + ' (inactive)'">#{{ s.number }} {{ s.name }}</span>
            <span *ngIf="r._systemsMore" class="kl-sys kl-sys--more">+{{ r._systemsMore }}</span>
          </div>
          <div class="kl-sub" *ngIf="r._unitSystems">+ {{ r._unitSystems }} in units</div>
        </td>
      </ng-container>

      <ng-container matColumnDef="groups">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="num">Groups</th>
        <td mat-cell *matCellDef="let r" class="num">
          {{ (r._unitCount ? r._treeGroups : r._groupCount) || '—' }}
          <div class="kl-sub kl-incl" *ngIf="r._unitCount && r._treeGroups">incl. units</div>
        </td>
      </ng-container>

      <ng-container matColumnDef="contract">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="num">Contract / mo</th>
        <td mat-cell *matCellDef="let r" class="num">
          <ng-container *ngIf="r._unitCount; else ownContract">
            {{ r._treeContract ? (r._treeContract | number:'1.0-0') + ' kr' : '—' }}
            <div class="kl-sub kl-incl" *ngIf="r._treeContract">incl. units</div>
          </ng-container>
          <ng-template #ownContract>{{ r._contractMonthly ? (r._contractMonthly | number:'1.0-0') + ' kr' : '—' }}</ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="sales">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="num"
            matTooltip="Frigg-app sales on the customer's systems so far this month, inc. VAT">Current month</th>
        <td mat-cell *matCellDef="let r" class="num">
          <ng-container *ngIf="(r._unitCount ? r._treeSales : r._sales) as sales; else noSales">
            {{ sales | number:'1.0-0' }} kr
            <div class="kl-sub kl-incl" *ngIf="r._unitCount">incl. units</div>
          </ng-container>
          <ng-template #noSales>
            <span class="kl-muted">{{ salesLoading || (r._unitCount ? r._treeSales : r._sales) === null ? '…' : '—' }}</span>
          </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="lastBilled">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="num">Last reconciled</th>
        <td mat-cell *matCellDef="let r" class="num">
          <ng-container *ngIf="(r._unitCount ? r._treeLast : r._lastBilled) as lb; else noBilled">
            <div>{{ lb.total | number:'1.0-0' }} kr</div>
            <div class="kl-sub kl-sub--end">{{ monthLabel(lb.month) }}<span *ngIf="r._unitCount"> · incl. units</span></div>
          </ng-container>
          <ng-template #noBilled><span class="kl-muted">—</span></ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="owner">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Owner</th>
        <td mat-cell *matCellDef="let r">{{ r.ownerName || '—' }}</td>
      </ng-container>

      <ng-container matColumnDef="tasks">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="num">Tasks</th>
        <td mat-cell *matCellDef="let r" class="num">
          <span *ngIf="!r._openTasks" class="kl-muted">—</span>
          <span *ngIf="r._openTasks" class="kl-pill" [class.kl-pill--risk]="r._overdueTasks"
                [matTooltip]="r._overdueTasks ? r._overdueTasks + ' overdue' : 'Open tasks'">{{ r._openTasks }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let r" class="kl-actions">
          <button mat-icon-button *ngIf="canDelete" aria-label="Delete customer" matTooltip="Delete customer" (click)="deleteKunde(r, $event)">
            <mat-icon>delete_outline</mat-icon>
          </button>
          <mat-icon class="kl-chevron">chevron_right</mat-icon>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let r; columns: displayedColumns" class="kl-row" [class.kl-row--unit]="r._depth === 1" (click)="showDetail(r)"
          tabindex="0" (keydown.enter)="showDetail(r)"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="kl-empty" [attr.colspan]="displayedColumns.length">
          {{ loading ? 'Loading customers…' : 'No customers match these filters.' }}
        </td>
      </tr>
    </table>
    <mat-paginator [pageSizeOptions]="[50, 100, 250, 1000]" [pageSize]="100" showFirstLastButtons></mat-paginator>
  </div>

  <app-kunde-kort-board *ngIf="viewMode === 'board'" [customers$]="filteredCustomers$" (openDetail)="showDetail($event)">
  </app-kunde-kort-board>
</div>
